import React from "react";
import styled from "@emotion/styled";
import { keyframes } from "@emotion/react";
import { NavLink } from "react-router-dom";

import { spacing } from "@mui/system";
import { green } from "@mui/material/colors";
import { useTheme } from "@mui/material/styles";

import {
  Box as MuiBox,
  Chip,
  Drawer as MuiDrawer,
  ListItemButton,
  CircularProgress,
} from "@mui/material";

// import { ReactComponent as Logo } from "../../vendor/logo.svg";
import Logo from "../../vendor/hyper_radius_logo.png";
import STLogo from "../../vendor/st_logo.png";
import Footer from "./SidebarFooter";
import SidebarNav from "./SidebarNav";

const Box = styled(MuiBox)(spacing);

const Drawer = styled(MuiDrawer)`
  border-right: 1px solid
    ${(props) =>
      props.theme.palette.mode === "dark" ? "rgba(255, 255, 255, 0.08)" : "rgba(0, 0, 0, 0.08)"};

  & .MuiDrawer-paper {
    border-right: 1px solid
      ${(props) =>
        props.theme.palette.mode === "dark" ? "rgba(255, 255, 255, 0.08)" : "rgba(0, 0, 0, 0.08)"};
    background-color: ${(props) => props.theme.sidebar.background} !important;
    color: ${(props) => props.theme.sidebar.color} !important;
  }
`;

const shimmer = keyframes`
  0% { left: -150%; }
  100% { left: 250%; }
`;

const Brand = styled(ListItemButton)`
  font-size: ${(props) => props.theme.typography.h5.fontSize};
  font-weight: 800;
  color: ${(props) => props.theme.sidebar.header.color};
  background: ${(props) =>
    props.theme.palette.mode === "dark"
      ? props.theme.sidebar.header.background
      : "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)"};
  font-family: ${(props) => props.theme.typography.fontFamily};
  min-height: 74px;
  padding-left: ${(props) => props.theme.spacing(4)};
  padding-right: ${(props) => props.theme.spacing(4)};
  justify-content: flex-start;
  cursor: pointer;
  flex-grow: 0;
  position: relative;
  overflow: hidden;
  border-bottom: 1px solid
    ${(props) =>
      props.theme.palette.mode === "dark" ? "rgba(255, 255, 255, 0.08)" : "rgba(0, 0, 0, 0.05)"};
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.03);
  z-index: 10;
  transition: all 0.4s ease;

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: -150%;
    width: 60%;
    height: 100%;
    background: linear-gradient(
      to right,
      transparent,
      ${(props) =>
        props.theme.palette.mode === "dark"
          ? "rgba(255, 255, 255, 0.1)"
          : "rgba(255, 255, 255, 0.9)"},
      transparent
    );
    transform: skewX(-25deg);
    animation: ${shimmer} 4s infinite linear;
  }

  &:hover {
    background: ${(props) =>
      props.theme.palette.mode === "dark" ? props.theme.sidebar.header.background : "#fff"};
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  }

  & .MuiBox-root {
    letter-spacing: 1.5px;
    color: ${(props) => (props.theme.palette.mode === "dark" ? "#f8fafc" : "#1e293b")};
    font-weight: 900;
  }
`;

// const BrandIcon = styled(Logo)`
//   margin-right: ${(props) => props.theme.spacing(2)};
//   color: ${(props) => props.theme.sidebar.header.brand.color};
//   fill: ${(props) => props.theme.sidebar.header.brand.color};
//   width: 32px;
//   height: 32px;
// `;

const BrandLogo = styled("img")`
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);

  &:hover {
    transform: scale(1.1) translateY(-2px);
  }
`;

const Sidebar = ({ items, showFooter = true, logoSrc, logoTextName, collapsed, ...rest }) => {
  const theme = useTheme();
  return (
    <Drawer theme={theme} variant="permanent" {...rest}>
      <Brand component={NavLink} to="/" theme={theme}>
        {logoSrc ? (
          <BrandLogo src={logoSrc} alt="Hyper Radius Logo" width={46} height={46} />
        ) : (
          <CircularProgress size={30} color="primary" />
        )}

        {!collapsed && (
          <Box
            ml={3}
            sx={{
              fontWeight: 700,
              whiteSpace: "nowrap",
              textTransform: "uppercase",
              letterSpacing: "1px",
              fontSize: "0.9rem",
              background:
                theme.palette.mode === "dark"
                  ? "linear-gradient(to right, #60a5fa, #93c5fd)"
                  : "linear-gradient(to right, #1e3a8a, #3b82f6)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            {logoTextName}
          </Box>
        )}
      </Brand>
      <SidebarNav items={items} collapsed={collapsed} />
      {/* {!!showFooter && <Footer />} */}
    </Drawer>
  );
};

export default Sidebar;
